<template>
  <div class="page">
    <com-banner></com-banner>
    <div class="header">
      <div class="header-gx"></div>
    </div>
    <div class="shoe">
      <div class="shoe-d">
        <div class="page3-shoe">
          <img :src="shoe.img" />
          <div class="shoe-name">{{ shoe.name }}</div>
          <div class="shoe-price"><span>¥ {{ shoe.price }}</span></div>
          <div class="shoe-size">尺码： <input type="text" v-model="size.value" readonly placeholder="请选择尺码" @click="size.show=true"></div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="btn btn3" @click="openApp"></div>
    </div>
    <com-footer></com-footer>
    <!-- 选择鞋码 -->
    <van-popup v-model="size.show" position="bottom">
      <van-picker title="请选择尺码" show-toolbar :columns="size.list" @confirm="handleSizeConfirm" />
    </van-popup>
  </div>
</template>

<script>
import comBanner from '@/components/banner'
import comFooter from '@/components/footer'

import { getShoe } from '@/utils/index'
import behavior from '@/utils/behavior'

const sizeList = []
for (let i = 34; i <= 46; i = i + 0.5) {
  sizeList.push(i)
}

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    isnew: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      size: {
        show: false,
        list: sizeList,
        value: this.info.helperSize ? this.info.helperSize : ''
      }
    }
  },
  computed: {
    shoe() {
      return getShoe(this.info.helperShoeId)
    }
  },
  methods: {
    openApp() {
      this.isnew
        ? behavior('前往球球大作战提货', '新用户打开')
        : behavior('前往球球大作战提货', '老用户打开')
      this.$emit('open', this.info.helperShoeId, this.size.value)
    },
    handleSizeConfirm(value, index) {
      this.size.value = value
      this.size.show = false
    }
  },
  components: {
    comBanner,
    comFooter
  }
}
</script>

<style lang="less" scoped>
@import '../assets/less/mixin.less';

.page3-shoe {
  text-align: center;
  img {
    display: block;
    margin: 0 auto .1rem;
    height: 5.4rem;
  }
  .shoe-name {
    line-height: .55rem;
    font-size: .42rem;
    color: #fff;
    .ellipsis();
  }
  .shoe-price {
    font-size: .7rem;
    color: #ff0060;
    .ellipsis();
    span {
      position: relative;
      // text-decoration: line-through;
      font-size: .5rem;
      color: #fc4b4f;
      &:after {
        position: absolute;
        left: -20%;
        top: 50%;
        display: block;
        content: "";
        width: 140%;
        height: .04rem;
        background: #fc4b4f;
      }
    }
  }
  .shoe-size {
    margin-top: .6rem;
    font-size: .3rem;
    color: #fff;
    input {
      width: 2rem;
      height: .55rem;
      line-height: .55rem;
      padding: 0 .2rem;
      text-align: center;
      background: #423d76;
      border: none;
      outline: none;
      border-radius: .06rem;
    }
    input::-webkit-input-placeholder { color: #7f96ff; }
    input:-moz-placeholder { color: #7f96ff; }
    input::-moz-placeholder { color: #7f96ff; }
    input:-ms-input-placeholder { color: #7f96ff; }
  }
}
@media screen and (min-height: 571px) and (max-height: 680px) {
  .page3-shoe {
    img{
      height: 4.6rem;
    }
    .shoe-name {
      line-height: .5rem;
    }
    .shoe-price {
      // font-size: .6rem;
    }
    .shoe-size {
      margin-top: .4rem;
    }
  }
}
@media screen and (min-height: 521px) and (max-height: 570px) {
  .page3-shoe {
    img{
      height: 4rem;
    }
    .shoe-name {
      line-height: .5rem;
    }
    .shoe-price {
      // font-size: .6rem;
    }
    .shoe-size {
      margin-top: .2rem;
    }
  }
}
@media screen and (min-height: 461px) and (max-height: 520px) {
  .page3-shoe {
    img{
      height: 3.4rem;
    }
    .shoe-name {
      line-height: .5rem;
    }
    .shoe-price {
      // font-size: .6rem;
    }
    .shoe-size {
      margin-top: .2rem;
    }
  }
}
@media screen and (max-height: 460px) {
  .page3-shoe {
    img{
      height: 3rem;
    }
    .shoe-name {
      line-height: .5rem;
    }
    .shoe-price {
      // font-size: .6rem;
    }
    .shoe-size {
      margin-top: .2rem;
    }
  }
}
</style>
